<div class="faspinner" *ngIf="loading">
  <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
</div>
<div *ngIf="!loading">
  <!-- <app-back-page (backAction)="backToMainPage($event)"></app-back-page> -->
  <div id="form-container">
    <form (submit)="onFormSubmit($event)">
      <dx-form       labelMode="floating" labelLocation="top" id="form" [(formData)]="extratimeform" [showColonAfterLabel]="true" [showValidationSummary]="true"
        validationGroup="customerData" style="padding: 1rem 2rem;margin: 2rem 0rem;">
        <dxi-item itemType="group" caption="{{'workSystemSetting.ExtraTimeRules'|translate}}" [colCount]="12">
          <dxi-item dataField="nameAr" [colSpan]="6">
            <dxi-validation-rule type="required" message="{{'errors.namerequired'|translate}}">
            </dxi-validation-rule>
            <!-- <dxi-validation-rule
              type="async"
              message="{{'errors.token'|translate}} !!" 
              [validationCallback]="validateAsync"
            >
            </dxi-validation-rule> -->
            <dxo-label text="{{'tableinfo.NameAr'|translate}}"></dxo-label>
          </dxi-item>
          <dxi-item dataField="nameEn" [colSpan]="6">
            <dxo-label text="{{'tableinfo.NameEn'|translate}}"></dxo-label>
          </dxi-item>
          <dxi-item dataField="dateOfRegistration" editorType="dxDateBox" [colSpan]="6" [disabled]="true">
            <dxo-label text="{{'tableinfo.dateOfRegistration'|translate}}"></dxo-label>
          </dxi-item>

          <dxi-item dataField="durationType" editorType="dxLookup" [colSpan]="6"
            [editorOptions]="{dataSource: durationType, displayExpr:'name' ,valueExpr :'code' ,searchEnabled: true, showClearButton: true}">
            <dxo-label text="{{'workSystemSetting.DeductionRules.Timing' |translate}}"></dxo-label>
          </dxi-item>


          
          <dxi-item dataField="type" editorType="dxLookup" [colSpan]="6"
            [editorOptions]="{dataSource:typeStatus, displayExpr:'name' ,valueExpr :'code' ,searchEnabled: true, showClearButton: true}">
            <dxo-label text="{{'tableinfo.type'|translate}}"></dxo-label>
          </dxi-item>




          <dxi-item dataField="taxableStatus" editorType="dxLookup" [colSpan]="6"
            [editorOptions]="{dataSource: TaxableStatus, displayExpr:'name' ,valueExpr :'id' ,searchEnabled: true, showClearButton: true}">
            <dxo-label text="{{'tableinfo.taxStatus'|translate}}"></dxo-label>
          </dxi-item>
          <dxi-item dataField="fromRule" editorType="dxNumberBox" [colSpan]="6">
            <dxo-label text="{{'tableinfo.from'|translate}}"></dxo-label>
            <dxi-validation-rule type="range" [min]="0" message="{{'errors.min'|translate}}"></dxi-validation-rule>
          </dxi-item>
          <dxi-item dataField="toRule" editorType="dxNumberBox" [colSpan]="6">
            <dxo-label text="{{'tableinfo.to'|translate}}"></dxo-label>
            <dxi-validation-rule type="range" [min]="0" message="{{'errors.min'|translate}}"></dxi-validation-rule>
            <dxi-validation-rule type="range" [min]="extratimeform.fromRule?extratimeform.fromRule:0"
              message="{{'errors.greater'|translate}}"></dxi-validation-rule>
          </dxi-item>

          <!-- <dxi-item dataField="type" editorType="dxLookup" [colSpan]="6"
              [editorOptions]="{dataSource: typeDropDown, displayExpr:'name' ,valueExpr :'code'}">
                <dxo-label text="{{'tableinfo.type'|translate}}"></dxo-label>
                <dxi-validation-rule type="required" message="{{'errors.namerequired'|translate}}">
                </dxi-validation-rule>
              </dxi-item> -->

          <dxi-item dataField="description" [colSpan]="6">
            <dxo-label text="{{'tableinfo.description'|translate}}"></dxo-label>
          </dxi-item>

          <dxi-item dataField="isActive" editorType="dxCheckBox" [colSpan]="6">
            <dxo-label text="{{'addemployee.tab4.isActive'|translate}}"></dxo-label>
          </dxi-item>

          <dxi-item [colSpan]="12" class="custom-setting">
            <!-- <h6 style="margin:10px 0px;text-align: center;">{{'workSystemSetting.ExtraTimeRules'|translate}}</h6> -->
            <dx-data-grid id="gridContainer" [dataSource]="DetailsDataSource" [showBorders]="false"
              [columnAutoWidth]="true" [columnHidingEnabled]="true" [showColumnLines]="false"
              [rowAlternationEnabled]="true" [showRowLines]="false" [showBorders]="false" [errorRowEnabled]="false"
              [rtlEnabled]="currentLang=='ar'?true:false" (onInitNewRow)="onInitNewRow($event)"
              (onEditingStart)="onEditingStart()">
              <dxo-paging [pageSize]="3"> </dxo-paging>
              <dxo-editing mode="cell" [allowUpdating]="false" [allowAdding]="true" [allowDeleting]="true"
                [texts]="button">
                <dxo-texts [addRow]="addrowfun('addemployee.tab4.Benfits')"
                  confirmDeleteMessage="{{'tableinfo.deletebutton'|translate}}" SaveConfirm>
                </dxo-texts>
              </dxo-editing>
              <dxi-column dataField="countRule" caption="{{'workSystemSetting.countRule'|translate}}" dataType="number">
                <dxi-validation-rule type="range" [min]="0" message="{{'errors.min'|translate}}"></dxi-validation-rule>
              </dxi-column>
              <dxi-column dataField="ruleValue" caption="{{'workSystemSetting.ruleValue'|translate}}" dataType="number">
                <dxi-validation-rule type="range" [min]="0" message="{{'errors.min'|translate}}"></dxi-validation-rule>
              </dxi-column>
            </dx-data-grid>

          </dxi-item>
        </dxi-item>
        <dxi-item itemType="button" horizontalAlignment="left" [buttonOptions]="buttonOptions">
        </dxi-item>
      </dx-form>
    </form>
  </div>

</div>